// Constants for preset attributes and CSS properties
export const DATA_PRESET_ATTRIBUTE = 'data-preset'
export const CSS_PRESET_PREFIX = '--preset'
export const COMPONENT_CLASS_PREFIX = 'w-'
export const ROOT_ELEMENT_KEY = 'root'

// DOM element IDs
export const WIX_WARMUP_DATA_ELEMENT_ID = 'wix-warmup-data'
